(function() {
  
  'use strict';
  
  angular
  .module('ATMGCart')
  .factory('CartService', CartService);
  
  CartService.$inject = ['ApiQuery'];
  
  function CartService(ApiQuery) {
    
    // status can now be shared with client classes (in whose we inject this factory into)
    this.status = {
      loading: false,
      error: false
    }
    
    // loader will toggle the specified property state
    // according to the number of items left in the queue
    // start(item) / finish(item) to update queue
    var loader = new Loader(this.status, 'loading');
    
    return {
      status: this.status,
      check: function() {
        return fire.call(this, 'cart/check', null, 'GET');
      },
      count: function(cart_id) {
        if (cart_id) {
          return fire.call(this, 'cart/count/' + cart_id, '', 'GET');
        }
        return fire.call(this, 'cart/count', '', 'GET');
      },
      headers: function(cart_id) {
        if (cart_id) {
          return fire.call(this, 'account/carts/orders/' + cart_id, '', 'GET');
        }
        return fire.call(this, 'cart/orders', '', 'GET');
      },
      details: function(cart_id) {
        if (cart_id) {
          return fire.call(this, 'account/carts/details/' + cart_id, '', 'GET');
        }
        // cart_id = cart_id || '';
        return fire.call(this, 'cart/details/', '', 'GET');
      },
      lines: function(cart_id) {
        if (cart_id) {
          return fire.call(this, 'account/carts/lines/' + cart_id, '', 'GET');
        }
        return fire.call(this, 'cart/lines/', '', 'GET');
      },
      totals: function(cart_id) {
        if (cart_id) {
          return fire.call(this, 'account/carts/totals/' + cart_id, '', 'GET');
        }
        return fire.call(this, 'cart/totals/', '', 'GET');
      },
      orderTotals: function(order_id) {
        // return fire.call(this, 'customer/order-totals/' + order_id, '', 'GET');
        return fire.call(this, 'account/orders/totals/' + order_id, '', 'GET');
      },
      add: function(payload) {
        return fire.call(this, 'cart/items', payload, 'POST');
      },
      update: function(payload) {
        let id = payload.item_id
        delete payload.item_id
        return fire.call(this, 'cart/items/' + id, payload, 'PUT');
      },
      remove: function(payload) {
        return fire.call(this, `cart/items/${payload.item_id}`, '', 'DELETE');
      },
      // validate: function() {
      //     return fire.call(this, 'cart/validate', null, 'GET');
      // }
      charge: function(payload, cart_id) {
        cart_id = cart_id || ''
        return fire.call(this, 'cart/charge/' + cart_id , payload, 'POST');
      },
      cwi_order: function(order_id) {
        // return fire.call(this, 'customer/repair-order-link/' + order_id, '', 'GET')
        return fire.call(this, 'account/cwi/order-link/' + order_id, '', 'GET')
      },
      getCustomerNote: function(line_id, cart_id) {
        if (cart_id != null) {
          return
        } else {
          return fire.call(this, 'cart/customer-note/' + line_id, '', 'GET')
        }
      },
      setCustomerNote: function(payload) {
        return fire.call(this, 'cart/customer-note/' + payload.line_id, {note: payload.note}, 'POST')
      }
    }
      
      // generic api request fire
      function fire(endpoint, payload, method) {
        var self = this;
        loader.start(endpoint);
        return ApiQuery(endpoint, payload, method)
        .then(function(response) {
          loader.finish(endpoint)
            if (response.data) {
              return response.data
            }
            return response
          }).catch(error => {
            loader.finish(endpoint)
            throw error
          })
        }
      }
      
      /**
      *   true/false pilots the property prop of passed status object based on the number
      *   of loading items on the loading queue
      */
      function Loader(status, prop) {
        
        this.loading = [];
        
        this.start = function(item) {
          this.loading.push(item);
          // console.log('start: '+ item + ' length: ' + this.loading.length)
          status[prop] = !!this.loading.length;
        }
        
        this.finish = function(item) {
          if (this.loading.indexOf(item) > -1) {
            this.loading.splice(this.loading.indexOf(item), 1);
          }
          // console.log('finish: '+ item + ' length: ' + this.loading.length)
          status[prop] = !!this.loading.length;
        }
        
      }
      
    })()


// WEBPACK FOOTER //
// ./src/app/modules/Cart/services/CartService.js